import { ColorScheme } from '../../types'
import { COLOR_SCHEME } from '../constants'
import { AppAction, AppStateType, SettingsType } from '../constants/enums'
import { updateAppState } from '../state/state.app'
import { getCookie, setCookie } from '../utilities/cookies'
import { saveSettings } from './settings'
import { appAction } from './workerActions'

/** Get the dark mode setting from the cookie (client side only) */
export const getColorSchemeCookie = (): ColorScheme => {
    if (typeof window === 'undefined') return
    const darkModeCookie = getCookie(COLOR_SCHEME)
    if (darkModeCookie !== 'dark' && darkModeCookie !== 'light') return 'system'
    return darkModeCookie
}

export const setDarkMode = (darkMode: boolean) => {
    updateAppState(AppStateType.APP, { darkMode }, true)
    // worker needs dark mode state for emote parsing
    appAction(AppAction.SET_DARK_MODE, darkMode)
    if (darkMode) {
        document.body.classList.add('DARK_MODE')
    } else {
        document.body.classList.remove('DARK_MODE')
    }
}

export const setColorScheme = (
    changedSetting: ColorScheme,
    saveSetting?: boolean,
) => {
    if (changedSetting === 'system') {
        const systemPrefersDark = window.matchMedia(
            '(prefers-color-scheme: dark)',
        ).matches
        setDarkMode(systemPrefersDark)
    } else {
        const darkMode = changedSetting === 'dark'
        setDarkMode(darkMode)
    }
    if (saveSetting) {
        saveSettings(SettingsType.DEFAULT, 'colorScheme', changedSetting)
        setCookie(COLOR_SCHEME, changedSetting)
    }
}
